// ThervuMitra's languages, in the order shown to users: English and Tamil.
// `label` is the language's own name in its own script; `name` is English.
// `dir` marks right-to-left scripts. THERVUMITRA_LANGUAGES in lms.yml (MFE_CONFIG)
// can override the list; entries there use the same shape.
export const ALL_LANGUAGES = [
  { code: 'en', label: 'English', name: 'English' },
  { code: 'ta', label: 'தமிழ்', name: 'Tamil' },
];

export const RTL_LANGUAGES = ALL_LANGUAGES.filter(l => l.dir === 'rtl').map(l => l.code);
